/**
 * lodash, jQuery, Popper and Bootstrap's JavaScript used to be loaded here —
 * the Laravel scaffold's defaults. Nothing in resources/js or in any Blade
 * used them, and together they were ~950 KB of source in app.js, downloaded
 * and executed on every screen (#58). The UI is Vuetify.
 *
 * axios stays: it is also imported by services/, and the global keeps the
 * X-Requested-With default for anything that still reaches for window.axios.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
